import { render } from "./MyProfile.vue?vue&type=template&id=5bbc82b2&scoped=true"
import script from "./MyProfile.vue?vue&type=script&lang=js"
export * from "./MyProfile.vue?vue&type=script&lang=js"

import "./MyProfile.vue?vue&type=style&index=0&id=5bbc82b2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bbc82b2"]])

export default __exports__